module.exports = __webpack_public_path__ + "img/icon9.4eeef4d1.png";